function IvoryCoast({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1412)">
        <path d="M16 32C17.9571 32 19.8319 31.648 21.5652 31.0048L22.2609 16L21.5653 0.995188C19.8319 0.352063 17.9571 0 16 0C14.0429 0 12.1681 0.352063 10.4348 0.995188L9.73914 16L10.4348 31.0048C12.1681 31.648 14.0429 32 16 32Z" fill="#F0F0F0"/>
        <path d="M0 15.9999C0 22.8794 4.342 28.7441 10.4348 31.0047V0.995117C4.342 3.2558 0 9.12049 0 15.9999Z" fill="#FF9811"/>
        <path d="M21.5652 0.995117V31.0048C27.658 28.7441 32 22.8794 32 15.9999C32 9.12049 27.658 3.2558 21.5652 0.995117Z" fill="#6DA544"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default IvoryCoast;
